// @flow

import GooglePublisherTag, { targeting } from '@seek/seek-react-gpt';
import { metrics } from '@seek/metrics-js';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { advertsIsEnabled } from 'src/config';

import { isClientDesktopWidth } from 'src/modules/responsive-helpers';

type Props = {
  targetingData: Array<any>, // naughty, but no idea what this is
  tagId: string,
  width: number,
  height: number
};

type State = {
  shouldRenderAdverts?: boolean
};

const createGptLogger = tagId => {
  const match = tagId.match(/\/\d+\/(.*)/) || [];
  const metricTagName = match.length ? match[1] : tagId;

  return () => {
    metrics.count('advertisements', [`tag-id:${metricTagName}`]);
  };
};

const makeHoustonAdTargetingSelector = () =>
  createSelector(
    state => state.search.query,
    state => state.results.location || {},
    (query, location) => ({
      targetingData: targeting.search(query, location)
    })
  );

class HoustonAd extends Component<Props, State> {
  state = {
    shouldRenderAdverts: false
  };

  componentDidMount() {
    if (isClientDesktopWidth()) {
      this.setState({ shouldRenderAdverts: true }); // eslint-disable-line
    }
  }

  render() {
    const { tagId, targetingData, width, height } = this.props;
    const { shouldRenderAdverts } = this.state;

    return advertsIsEnabled && shouldRenderAdverts ? (
      <GooglePublisherTag
        tagId={tagId}
        width={width}
        height={height}
        lotameTargeting={true}
        targetingData={targetingData}
        logger={createGptLogger(tagId)}
      />
    ) : null;
  }
}

export default connect(makeHoustonAdTargetingSelector)(HoustonAd);
